<template>
	<div class="xs-12 p4">
		<note-form @submit="handleSubmit" :data="data">
			<template slot-scope="{ onSubmit }">
				<j-button :isLoading="isUpdateLoading" @click="onSubmit">
					{{ $t("save") }}
				</j-button>
			</template>
		</note-form>
	</div>
</template>

<script>
/**
 * This component is responsible for creation of note
 * We can do createEntityNote or createPolicyNote
 */
import NoteForm from "./NoteForm.vue"
import JButton from "@/components/JButton"
import api from "../../api/"

export default {
	components: { NoteForm, JButton },

	props: {
		/**
		 * Id of policy or entity we are adding note to
		 */
		id: {
			type: String,
			required: true,
			default: ""
		},

		notesOf: {
			type: String,
			required: true
		},

		data: {
			type: Object,
			required: true,
			default: () => ({
				id: null,
				title: null,
				content: null
			})
		}
	},

	data: () => ({
		isUpdateLoading: false
	}),

	methods: {
		async handleSubmit(payload) {
			// Decide if it's adding for policy, entity or claim
			let apiKey = null

			if (this.notesOf === "policy")
				apiKey = {
					query: "updatePolicyNote",
					inputKey: "updateNoteInput",
					variable: "policyId"
				}

			if (this.notesOf === "claim")
				apiKey = {
					query: "updateClaimNote",
					inputKey: "input",
					variable: "claimId"
				}

			if (this.notesOf === "individual" || this.notesOf === "company")
				apiKey = {
					query: "updateEntityNote",
					inputKey: "updateNoteInput",
					variable: "entityId"
				}

			if (this.notesOf === "case")
				apiKey = {
					query: "updateNoteOfCase",
					inputKey: "input",
					variable: "caseId"
				}

			this.isUpdateLoading = true
			const variables = {
				[apiKey.inputKey]: {
					id: payload.id,
					title: payload.title,
					content: payload.content
				},
				[apiKey.variable]: this.id
			}

			/**
			 * For case, we have new API and it has slightly different convention
			 */
			if (this.notesOf === "case") {
				variables.noteId = payload.id
			}

			// Call api
			const res = await api[apiKey.query](variables)
			this.isUpdateLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("note:updated")
		}
	}
}
</script>